(function ManagerAgentForm($, HE)
{
	"use strict";

	var form = {
		name: 'Agent',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.add-ip-range').click(function addIps() {
			var $self = $(this),
			    opp   = $self.data('opposite');

			// show or hide row for adding
			$('#new-ips').toggleClass('d-none');

			// enable or disable inputs on the row
			$('#new-ips input[type=text]').prop('disabled', function opposite(i, v) { return !v; });

			// set the data attribute if the user toggles back and forth
			$self.data('opposite', $self.html());

			// change the text of link
			$self.html(opp);
		});
	};
}(jQuery, window.HE || {}));
